import { createFileRoute } from '@tanstack/react-router';

import { WorkspaceSessionListScreen } from '@/features/sessions/components/workspace/SessionListScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/sessions/')({
  beforeLoad: () => {
    requirePermission('session:read');
  },
  component: WorkspaceSessionListScreen,
  staticData: { crumb: 'Sessions' },
});
